// eslint-disable-next-line import/no-extraneous-dependencies
import { Banner } from 'baby-design'

export interface NavigationCardProps {
  headline: string
  bodyCopy: string
  graphicIcon: React.ReactNode
  buttonHref: string
  testid: string
}
const NavigationCard: React.FC<NavigationCardProps> = ({
  headline,
  bodyCopy,
  graphicIcon,
  buttonHref,
  testid,
}) => (
  <div data-testid={testid}>
    <Banner
      bodyCopy={bodyCopy}
      button={{
        buttonVariant: 'tertiary',
        buttonText: 'View',
        href: buttonHref,
      }}
      color="default"
      dismissable={false}
      graphic={{
        icon: graphicIcon,
        placement: 'left',
      }}
      headline={headline}
      variant="ultra-compact"
    />
  </div>
)

export default NavigationCard
